// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Orders_ServiceOrdersResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

import type { Orders_ServiceOrderRow } from './Orders_ServiceOrderRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type Orders_ServiceOrdersResponseDados = Orders_ServiceOrderRow[];

export type Orders_ServiceOrdersResponse = ApiResponse<Orders_ServiceOrdersResponseDados>;

registerResponseContract('Orders_ServiceOrdersResponse', {
  _root: {
    type: 'array',
    required: true,
    items: {
      so_order_id:               { type: 'number',  required: true },
      so_order_franchise_id:     { type: 'number',  required: true },
      so_order_status:           { type: 'string',  required: true },
      so_order_financial_status: { type: 'string',  required: true },
      so_order_total:            { type: 'number',  required: true },
      so_order_total_recebido:   { type: 'number',  required: true },
      so_order_total_pendente:   { type: 'number',  required: true },
      so_order_client_name:      { type: 'string',  required: false },
      franquia:                  { type: 'string',  required: false },
      cliente_ddi:               { type: 'string',  required: false },
      cliente_ddd:               { type: 'string',  required: false },
      cliente_telefone:          { type: 'string',  required: false },
      cliente_email:             { type: 'string',  required: false },
      cliente_cpf:               { type: 'string',  required: false },
      cliente_document_type:     { type: 'string',  required: false },
      so_order_items_count:      { type: 'number',  required: true },
      items: {
        type: 'array',
        required: false,
        items: {
          so_order_item_id:                   { type: 'number',  required: true },
          current_step_name:                  { type: 'string',  required: false },
          prazo_status:                       { type: 'string',  required: true },
          urgency_score:                      { type: 'number',  required: true },
          days_until_due:                     { type: 'number',  required: false },
          so_order_item_expected_delivery_at: { type: 'string',  required: false },
          item_status:                        { type: 'string',  required: true },
        },
      },
      matched_field:             { type: 'string',  required: false },
      matched_item_id:           { type: 'number',  required: false },
      matched_value:             { type: 'string',  required: false },
      matched_attribute_name:    { type: 'string',  required: false },
    },
  },
})
